import React, { useState } from 'react'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { allProductGroupsAtom } from '../../../api/masters.atoms'
import { useGroupForProduct } from '../../../api/tree.hooks'
import { addProductsToGroup, removeProductFromGroup } from './utility'
import { Box, Button } from '@mui/material'
import { SelectGroupDropdown } from './SelectGroup'

export function ProductGroup({ productId }: { productId: number }) {
  const [editing, setEditing] = useState(false)
  const groupsRefresh = useSetAtom(allProductGroupsAtom)
  const productGroup = useGroupForProduct(productId)

  const onGroupSelect = async (groupId: number) => {
    if (productGroup) {
      await removeProductFromGroup(productGroup, productId)
    }
    await addProductsToGroup({ id: groupId }, [productId])
    groupsRefresh()
    setEditing(false)
  }

  if (editing) {
    return (
      <Box>
        <span>
          <strong>Group:</strong>{' '}
          <SelectGroupDropdown
            selectedId={productGroup?.id}
            onSelect={onGroupSelect}
          />{' '}
          <Button onClick={() => setEditing(false)}>Done</Button>
        </span>
      </Box>
    )
  }

  return (
    <Box>
      <span>
        <strong>Group:</strong>{' '}
        {productGroup ? `${productGroup.id}: ${productGroup.name}` : '(none)'}{' '}
        <Button onClick={() => setEditing(true)}>Edit</Button>
      </span>
    </Box>
  )
}
